import {EPermissions, ScreenProp} from 'src/app/models'

type TKeys =
  | 'USER_ADMIN'
  | 'USER_ADMIN_LIST'
  | 'USER_ADMIN_ADD'
  | 'USER_ADMIN_DETAIL'
  | 'USER_ADMIN_EDIT'
  | 'USER_ADMIN_UPLOAD'

export const AdminScreen: Record<TKeys, ScreenProp> = {
  USER_ADMIN: {
    PATH: '/user/admin',
    TITLE: 'Admin',
    TITLE_ALT: 'Admin',
  },
  USER_ADMIN_LIST: {
    PATH: '/user/admin/list',
    TITLE: 'Admin',
    TITLE_ALT: 'Admin',
    PERMISSION: [EPermissions.ADMIN_READ],
  },
  USER_ADMIN_ADD: {
    PATH: '/user/admin/add',
    TITLE: 'Buat Admin',
    TITLE_ALT: 'Buat Admin',
    PERMISSION: [EPermissions.ADMIN_CREATE],
  },
  USER_ADMIN_DETAIL: {
    PATH: '/user/admin/detail/:id',
    TITLE: 'Detail Admin',
    TITLE_ALT: 'Detail Admin',
    PERMISSION: [EPermissions.ADMIN_READ],
  },
  USER_ADMIN_EDIT: {
    PATH: '/user/admin/edit/:id',
    TITLE: 'Edit Admin',
    TITLE_ALT: 'Edit Admin',
    PERMISSION: [EPermissions.ADMIN_UPDATE],
  },
  USER_ADMIN_UPLOAD: {
    PATH: '/user/admin/upload',
    TITLE: 'Upload Admin',
    TITLE_ALT: 'Upload Admin',
    PERMISSION: [EPermissions.ADMIN_CREATE],
  },
}
